import { Button, FileUpload, FormField } from "@wix/design-system";
import React, { useContext } from "react";
import { EditorContext, RicosContext, useDevService } from "./../../ricos-context";
import { MEDIA_POPOVERS_BUTTONS_NAMES_BI } from "./../../wix-rich-content-common";
import { UPLOAD_TAB_UPLOAD_BUTTON } from "../data-hooks";
import { handleVideoUpload } from "../handle-video-upload";
import { VIDEO_TYPE } from "../types";
const FILE_INPUT_ACCEPT = "video/*";
const UploadVideo = ({
  nodeId,
  helpers,
  enableCustomUploadOnMobile,
  uploadService,
  closeModal,
  disableDownloadDefault,
  handleFileSelection,
  handleFileUpload,
  logBi
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const devService = useDevService();
  const hasCustomFileUpload = Boolean(handleFileUpload || handleFileSelection);
  const showUploadSection = (!isMobile || enableCustomUploadOnMobile) && hasCustomFileUpload;
  const handleUploadClick = async () => {
    helpers?.onPluginsPopOverClick?.({
      pluginId: VIDEO_TYPE,
      buttonName: MEDIA_POPOVERS_BUTTONS_NAMES_BI.upload
    });
    logBi({ dataHook: UPLOAD_TAB_UPLOAD_BUTTON });
    handleVideoUpload({
      services: { uploadService, devService },
      config: { disableDownloadDefault, handleFileSelection, handleFileUpload },
      publicCommands: getPublicCommands(),
      nodeId
    });
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(FormField, { label: t("VideoCustomUploadModal_Title"), maxLines: 2 }, showUploadSection ? /* @__PURE__ */ React.createElement(FileUpload, { onChange: () => {
  }, accept: FILE_INPUT_ACCEPT }, () => /* @__PURE__ */ React.createElement(
    Button,
    {
      dataHook: UPLOAD_TAB_UPLOAD_BUTTON,
      onClick: handleUploadClick,
      fullWidth: true,
      size: "small"
    },
    t("VideoUploadModal_CustomVideoClickText")
  )) : null);
};
export {
  UploadVideo
};
//# sourceMappingURL=upload-video.js.map
